import React from 'react';
import { ShieldCheck, ScrollText, Users, Clock } from 'lucide-react';
const POINTS = [{
  icon: ShieldCheck,
  title: 'Advice, not just paperwork',
  body: 'A qualified solicitor reviews your matter, so questions of legal risk are answered properly rather than passed on.'
}, {
  icon: ScrollText,
  title: 'Clear scope and fee upfront',
  body: 'You receive the proposed scope and fee before any work begins. No surprises once the matter is underway.'
}, {
  icon: Users,
  title: 'One point of contact',
  body: 'You deal with the team handling your file directly, from first contact through to settlement.'
}, {
  icon: Clock,
  title: 'Deadline aware',
  body: 'Tell us about any auction, offer or signing date and the team assesses how quickly the matter needs to move.'
}];
export function WhyLawyerLed() {
  return <section className="px-5 md:px-6 py-20 md:py-28 bg-background" data-id="element-565">
      <div className="max-w-7xl mx-auto" data-id="element-566">
        <div className="max-w-2xl mb-12" data-id="element-567">
          <p className="font-script text-2xl text-accent mb-1" data-id="element-568">
            why lawyer-led
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-569">
            A boutique firm, not a contract factory.
          </h2>
          <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-570">
            Both lawyers and licensed conveyancers can manage conveyancing work.
            A property lawyer can also advise when a transaction becomes more
            complex, so you are covered if something unexpected appears.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-571">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="rounded-2xl bg-surface border border-border p-6 shadow-card" data-id="element-572">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-brand-blue-light text-brand-blue mb-4" data-id="element-573">
                  <Icon className="w-6 h-6" data-id="element-574" />
                </span>
                <h3 className="font-serif text-lg text-ink" data-id="element-575">{point.title}</h3>
                <p className="mt-2 text-sm text-muted-ink leading-relaxed" data-id="element-576">
                  {point.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}